import $axios from './requestAxios'
import router from '../router/index'
import ls from './ls'
import {isAddressId} from './addressId'
import { Toast } from 'vant';

export default {
  //不强制添加默认地址  有默认地址就设置默认地址  没有的话选择地址列表的第一个地址  默认选中的addressid删除后 把第一项设置为默认,保证address每次都有值
  getIsDefault: (addressinfo) => {
    let addressId = isAddressId.fetch()
    if(addressId==''){
      isAddressId.save(addressinfo[0].id)
    }
    let addresslist = addressinfo.filter(value => {
      return value.is_default == 1;
    })[0];
    if(typeof(addresslist)=='undefined'){
      addresslist = addressinfo[0]
    }
    return addresslist
  },
  isXLYP: (cpUid) => {
    return false
    if (cpUid == 1215 || cpUid == 10030) {
      return true
    } else {
      return false
    }
  },
  showXLYPText () {
    Toast("商城近期改版，敬请期待哦...")
  },
  // 加入购物车小球移动 form：触发点  to：目标点
  addCartMove (from, to) {
    return new Promise((resolve, reject) => {
      let body = document.querySelector("body")
      let el = document.createElement("div")
          el.className = 'move_ball'
          body.appendChild(el)
      let eW = el.offsetWidth
      let eH = el.offsetHeight
          el.style.left = from.x - eW / 2 + 'px'
          el.style.top = from.y - eH / 2 + 'px'

      let x = to.x - from.x
      let y = to.y - from.y
      let ratioX = y / 5
      let ratioY = x / 5

      let timer
      if (Math.abs(x) > Math.abs(y)) {
        timer = setInterval(moveX, 10)
      } else {
        timer = setInterval(moveY, 10)
      }
      let numX = 0
      let numY = 0

      function moveY () {
        if (numY + from.y < to.y) {
          numX += x / ratioX
          numY += 5
        } else {
          clearInterval(timer)
          body.removeChild(el)
          resolve({
            status: 'success'
          })
        }
        el.style.top = from.y + numY - 5 + 'px'
        el.style.left = from.x + numX - 5 + 'px'
      }

      function moveX () {
        if (numX > to.x -  from.x) {
          numX -= 5
          numY -= y / ratioY
        } else {
          clearInterval(timer)
          body.removeChild(el)
          resolve({
            status: 'success'
          })
        }
        el.style.top = from.y + numY - 5 + 'px'
        el.style.left = from.x + numX - 5 + 'px'
      }
    })
  },
  // 传入DOM元素 获取该元素绝对位置
  getPos: (obj) => {
    let left = 0, top = 0;
    const w = obj.offsetWidth
    const h = obj.offsetHeight
    while (obj) {
      top += obj.offsetTop;
      left += obj.offsetLeft;
      obj = obj.offsetParent;
    }
    return {x: left + w / 2, y: top + h / 2};
  },
  // 获取购物车数据
  getShoppingCart () {
    return new Promise((resolve, reject) => {
      $axios({
        method: "POST",
        url: "/app/cart/list",
        success: data => {
          if (data.data.status == 'success') {
            resolve(data.data.data)
          } else {
            Toast(data.data.message)
            reject(data.data.message)
          }
        }
      })
    })
  },
  getPositionType () {
    return new Promise((resolve, reject) => {
      $axios({
        method: "POST",
        url: "/ad/position/type",
        data: {
          appId: ls.get('configInfo').app_id
        },
        success: data => {
          if (data.data.status == "success") {
            const res = data.data.data
            const obj = {}
            const isProgress = {}
            res.forEach(i => {
              obj[i.id] = i.is_new_user
            })
            resolve(obj)
          }
        }
      })
    })
  },
  getUa() {
    let ua = navigator.userAgent;
    if(ua.match(/wxwork/i) == 'wxwork')return 'wxwork';
    if (ua.match(/MicroMessenger/i) == 'MicroMessenger') {
      let t = ''
      wx.miniProgram && wx.miniProgram.getEnv(function(res) {
        if (res.miniprogram) {
          t = 'wxmi'
        } else {
          t = 'wx'
        }
      })
      console.log(t)
      return t;
    } else if ((ua.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )) == null) {
      console.log('设备:', 'PC端')
      return 'pc';
    } else {
      console.log('设备:', '移动端')
      return 'app';
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js